export const PupDocsRoutes = {
  PreFlight: `/pupdocs/preflight`,
  FileDetails: `/pupdocs/file-details`,
} as const;

export const DocumentStatus = {
  Approved: 'Approved',
  HealthReview: 'Health Review',
  NotIncluded: 'Not Included',
  PendingReview: 'Pending Review',
  Rejected: 'Rejected',
} as const;

export const PuppyStatus = {
  Finalized: 'FINALIZED',
  InReview: 'IN REVIEW',
  PendingReview: 'PENDING REVIEW',
  Urgent: 'URGENT',
} as const;

export const DocumentTypeId = {
  HealthCertificate: 1,
  VeterinaryHealthReport: 2,
  VaccinationRecord: 3,
} as const;
